import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import HomeCard1 from './sub_components/HomeCard1';
import Container from './atoms/Container';
import Contextapi from '../context-api/createContext';
import { baseUrl } from '../utils.jsx/baseUrl';
import {  DashboardIcon, LatestNews } from './svg/mainContainerIcons';
import DashboardAnalytics from './DashboardAnalytics';

function CarouselLoader() {
  return (
    <div className="relative w-full mx-auto">
      <div className="overflow-hidden rounded-2xl">
        <div className="w-full h-[380px] bg-gray-200 animate-pulse flex items-center justify-center rounded-2xl">
          <span className="text-gray-500">Loading...</span>
        </div>
      </div>
    </div>
  );
}


function Dashboard() {
  const navigate = useNavigate();
  const [notifiactionData, setNotifiactionData] = useState([]);
  const [isverified, setIsverified] = useState(false);
  const [loading , setLoading] = useState(true)
  const token = sessionStorage.getItem('token');
  const ckey = sessionStorage.getItem('client_key');
  useEffect(() => {
    (async () => {
      try {
        await axios.get(`${baseUrl.url}/auth/who-am-i`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setIsverified(true);
      } catch (error) {
        navigate('/login');
      }
    })();
  }, [isverified]);

  useEffect(() => {
    if (sessionStorage.getItem('id')) {
      sessionStorage.removeItem('id');
    }

    (async () => {
      try {
        const url = `${baseUrl.url}/notification/all`;

        const responce = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setNotifiactionData(responce.data);
      } catch (error) {
        console.log(error);
      } finally{
         setLoading(false)
      }
    })();
  }, [token]);
  return (
    <div className='flex flex-col gap-6 mt-10 mb-5'>
        <div className='flex flex-row gap-4 items-center mb-2'>
        <div><LatestNews /> </div>
        <div>
            <div className = "text-xl font-semibold">Latest News</div>
            <div className='text-sm text-[#615E5E]'>Stay Informed with our newest features and announcements  </div>
        </div>
        </div>

       {loading ? <CarouselLoader /> : notifiactionData.length > 0 ? <HomeCarousel cardsData = {notifiactionData}/> :  <div className="w-full h-[380px] flex items-center justify-center bg-gray-100 rounded-2xl text-gray-500">
    No Data Found
  </div>}

         <div className='flex flex-row gap-4 items-center mb-2 '>
        <div><DashboardIcon /> </div>
        <div>
            <div className = "text-xl font-semibold">Dashboard Analytics</div>
            <div className='text-sm text-[#615E5E]'>Real - time insights into your business performance and metrics </div>
        </div>
        </div>


        <div >
           <DashboardAnalytics />
        </div>
    </div>
  )
}




function HomeCarousel({ cardsData }) {
  const [current, setCurrent] = useState(0);

  const nextSlide = () => {
    setCurrent((prev) => (prev + 1) % cardsData.length);
  };

  const prevSlide = () => {
    setCurrent((prev) =>
      prev === 0 ? cardsData.length - 1 : prev - 1
    );
  };

  useEffect(() => {
    const timer = setInterval(() => {
      nextSlide();
    }, 5000); 

    return () => clearInterval(timer); 
  }, [cardsData.length]);

  return (
    <div className="relative w-full mx-auto">
      {/* Card wrapper */}
      <div className="overflow-hidden rounded-2xl">
        <div
          className="flex transition-transform duration-500"
          style={{ transform: `translateX(-${current * 100}%)` }}
        >
          {cardsData.map((data) => (
            <div className="w-full flex-shrink-0" key={data._id}>
              <HomeCard1
                {...{
                  description: data.description,
                  bgColor: "bg-[#258CFB]",
                  img: data.image_url,
                  title: data.title,
                  date: data.last_updated,
                  btnlabel: data.type,
                  btnlink: data.url,
                  id: data._id,
                }}
              />
            </div>
          ))}
        </div>
      </div>

      {/* Navigation buttons */}
      <button
        onClick={prevSlide}
        className="absolute top-1/2 left-2 -translate-y-1/2 bg-black/50 text-white px-3 py-1 rounded-full"
      >
        ‹
      </button>
      <button
        onClick={nextSlide}
        className="absolute top-1/2 right-2 -translate-y-1/2 bg-black/50 text-white px-3 py-1 rounded-full"
      >
        ›
      </button>

      {/* Dots */}
     <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2">
        {cardsData.map((_, idx) => (
          <button
            key={idx}
            onClick={() => setCurrent(idx)}
            className={`h-2 w-2 rounded-full transition-all ${
              idx === current ? "bg-blue-500" : "bg-gray-300"
            }`}
          />
        ))}
      </div>
    </div>
  );
}

export default Dashboard;
